import './quit-editing-modal.scss';
import React, { useEffect } from 'react';
import useCustomModal from '../custom-modal/custom-modal';

interface PropsQuitEditingModal {
    onDiscaredChanges: () => any;
    onStayEdit?: () => any;
    showModalCb?: (shouldClose: boolean) => void;
}

const renderBody = () => <div className="modal-commit-message">You have unsaved changes.</div>;

export const QuitEditingModal: React.FC<PropsQuitEditingModal> = ({ showModalCb, onStayEdit, onDiscaredChanges }) => {
    const [showModal, , contextHolder] = useCustomModal();

    useEffect(() => {
        showModal({
            wrapClassName: 'confirm-unsaved-modal-wrapper',
            width: 480,
            title: 'Quit Editing?',
            body: renderBody,
            okText: 'Continue Editing',
            cancelText: 'Discard Changes',
            onCancel: () => {
                onDiscaredChanges();
                showModalCb?.(false);
            },
            onOk: () => {
                onStayEdit?.();
                showModalCb?.(false);
            },
        });
    }, []);

    return <>{contextHolder}</>;
};
